<template>
    <div>
        <div class="advanced" :class="showAdvanced ? 'show' : 'hide'">
            <div class="row">
                
                <div class="col-md-4">
                    <!-- Filter by Programme -->
                    <SelectInput
                        :value="innerValue.programme ? innerValue.programme.Id : null"
                        @input="id => innerValue.programme = id ? Object.values($config.getValue('programmes')).filter(el => el.Id === id)[0] : null"
                        :label="$t('programme')"
                        :options="$config.getValue('programmes')"
                        optionLabel="Name"
                        optionValue="Id"
                        :nullLabel="$t('any')"
                    />
                </div>
                <div class="col-md-4">
                    <!-- Filter by Year -->
                    <SelectInput 
                        v-model="innerValue.year"
                        :label="$t('year')"
                        :options="innerValue.programme ? $config.getProgrammeYears(innerValue.programme.Id) : []"
                        :labelCb="year => $config.getYearStr(year, innerValue.programme.Id)"
                        :nullLabel="$t('any')"
                    />
                </div>
                <div class="col-md-4">
                    <!-- Filter by Group -->
                    <SelectInput 
                        v-model="innerValue.group"
                        :label="$t('group')"
                        :options="$config.getValue('groups')"
                        :indexIsValue="true"
                        :nullLabel="$t('any')"
                    />
                </div>
                <div class="col-md-4" v-if="canViewAllTests || isTeacher">
                    <!-- Filter by Student -->
					<div class="form-group">
						<label>{{ $t("student") }}</label>
						<div class="pseudo-input mb-3">
							<input
								type="search"
								class="input-bare w-full flex-1"
								placeholder="Student"
								v-if="!innerValue.students.length"
								@click="selectStudent"
							/>
							<span
								class="badge badge-secondary badge-sm mr-2 mb-2"
								v-for="(student, index) in innerValue.students"
								v-bind:key="index"
							>
								{{ student.displayName }}
								<a @click="removeStudent(student)"><b-icon icon="x"></b-icon></a>
							</span>
							<span
								class="badge badge-primary badge-sm mr-2 mb-2"
								v-if="innerValue.students.length"
								@click="selectStudent"
							>
								<b-icon icon="plus"></b-icon> {{ $t("add") }}
							</span>
							<span
								class="badge badge-danger badge-sm mr-2 mb-2"
								v-if="innerValue.students.length"
								@click="$emit('input', {...value, students: []})"
							>
								<b-icon icon="x"></b-icon> {{ $t('clear-all') }}
							</span>
						</div>
					</div>
				</div>
				<div class="col-md-4" v-if="canViewAllTests || isStudent">
                    <!-- Filter by Teacher -->
					<div class="form-group">
						<label>{{ $t("teacher") }}</label>
						<div
							class="pseudo-input mb-3"
						>
							<input
								type="search"
								class="input-bare w-full flex-1"
								placeholder="Teacher"
								v-if="!innerValue.teachers.length"
								@click="selectTeacher"
							/>
							<span
								class="badge badge-secondary badge-sm mr-2 mb-2"
								v-for="(teacher, index) in innerValue.teachers"
								v-bind:key="index"
							>
								{{ teacher.displayName }}
								<a @click="removeTeacher(teacher)"><b-icon icon="x"></b-icon></a>
							</span>
							<span
								class="badge badge-primary badge-sm mr-2 mb-2"
								v-if="innerValue.teachers.length"
								@click="selectTeacher"
							>
								<b-icon icon="plus"></b-icon> {{ $t("add") }}
							</span>
							<span
								class="badge badge-danger badge-sm mr-2 mb-2"
								v-if="innerValue.teachers.length"
								@click="clearTeachers"
							>
								<b-icon icon="x"></b-icon> {{ $t('clear-all') }}
							</span>
						</div>
					</div>
				</div>
                <div class="col-md-4">
                    <!-- Passed or Failed? -->
                    <SelectInput 
                        v-model="innerValue.haspassed" 
                        :label="$t('passed-failed')" 
                        :options="{ 1: $t('passed'), 0: $t('failed') }"
                        :indexIsValue="true"
                        :nullLabel="$t('all')"
                    />
				</div>
                <div class="col-md-4">
                    <!-- Marked or Unmarked? -->
					<SelectInput 
                        v-model="innerValue.marked" 
                        :label="$t('marked')" 
                        :options="{ '1': $t('marked'), '0': $t('not-marked')}"
                        :indexIsValue="true"
                        :nullLabel="$t('all')"
                    />
				</div>
				<div class="col-md-4">
                    <!-- Filters -->
					<div class="form-group">
						<!-- competencytestfilter_id (Category) -->
						<label>{{ $t("filter") }}</label>
						<input
							type="text"
							:value="innerValue.filter ? innerValue.filter.caption : null"
							class="form-control"
							@focus="selectFilter"
						/>
					</div>
				</div>
				<div class="col-md-4">
					<div class="form-group">
						<!-- test_id (Test) -->
						<label>{{ $t("test") }}</label>
						<input
							type="text"
							:value="innerValue.test ? innerValue.test.name : null"
							class="form-control"
							@focus="selectTest"
						/>
					</div>
				</div>
                <div class="col-md-4">
                    <!-- Filter by Abandoned Status -->
                    <SelectInput 
                        v-model="innerValue.abandoned" 
                        :label="$t('abandoned')" 
                        :options="{ 'include': $t('include-abandoned'), 'only': $t('only-abandoned') }"
                        :indexIsValue="true"
                        :nullLabel="$t('exclude-abandoned')"
                    />
				</div>

				<!-- Date range (from - to) on competencytestsession.comptencytest_datetaken -->
				<div class="col-md-4">
					<div class="form-group">
						<label>{{ $t('from') }}</label>
						<input
							type="date"
							v-model="innerValue.date_from"
							class="form-control"
							
						>
					</div>
				</div>
				<div class="col-md-4">
					<div class="form-group">
						<label>{{ $t('to') }}</label>
						<input
							type="date"
							v-model="innerValue.date_to"
							class="form-control"
							
						>
					</div>
				</div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 d-flex flex-row align-items-center justify-content-between">
                <SearchBar v-model="innerValue.search" placeholder="Search..." label="Search" />
                <button type="button" class="btn" :class="showAdvanced ? 'btn-primary' : 'btn-secondary'" @click="showAdvanced = !showAdvanced">{{ $t('advanced') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import SelectInput from "src/components/Inputs/SelectInput.vue"
import SearchBar from "src/components/Table/SearchBar.vue"

export default {
    components: {
        SelectInput,
        SearchBar,
    },
    props: {
        value: {
            type: Object,
            default: () => { 
                return  {
                    search: '',
                    students: [],
                    teachers: [],
                    programme: null,
                    year: null,
                    group: null,
                    haspassed: null,
                    marked: null,
                    filter: null,
                    test: null,
                    date_from: null,
                    date_to: null,
                }
            },
        },
    },
    mounted() {
        this.setDefaults()
    },
    data() {
        return {
            showAdvanced: false,
			innerValue: this.value,
        }
    },
    methods: {
        setDefaults() {
            const newVal = {
                search: '',
                students: [],
                teachers: [],
                programme: null,
                year: null,
                group: null,
                haspassed: null,
                marked: null,
                filter: null,
                test: null,
                date_from: null,
                date_to: null,
            }

            this.$emit('input', newVal)
        },
        selectTeacher() {
			const self = this;
			this.$users.getTeachers.call(this).then((teachers) => {
				const processedTeachers = teachers.map((teacher) => {
				if (teacher.status && teacher.status.toLowerCase() === "closed") {
					teacher.subcaption = this.$t("(Closed)");
				}
				return teacher;
				});
				this.$store.commit("openModal", {
				type: "selector",
				title: this.$t("select-a-teacher"),
				selectCallback: function (selection) {
					const isSelected = self.innerValue.teachers.find((teacher, i) => {
					if (teacher.id === selection.id) {
						self.$delete(self.innerValue.teachers, i);
						return true;
					}
					});
					if (!isSelected) self.innerValue.teachers.push(selection);
					self.$emit('input', self.innerValue);
				},
				selected: this.innerValue.teachers,
				data: processedTeachers,
				captionKey: "displayName",
				selectAllBtn: true
				});
			});
		},

		removeTeacher(selection) {
			const self = this;
			self.innerValue.teachers.find((teacher, i) => {
				if (teacher.id === selection.id) {
					self.$delete(self.innerValue.teachers, i);
					self.$emit('input', self.innerValue)
					return true;
				}
			});
			return false;
		},
        selectStudent() {
			const self = this;
			this.$users.getStudents.call(this).then((students) => {
				this.$store.commit("openModal", {
					type: "selector",
					title: this.$t("select-a-student"),
					selectCallback: function (selection) {
						const isSelected = self.innerValue.students.find((student, i) => {
							if (student.id === selection.id) {
								self.$delete(self.innerValue.students, i);
								return true;
							}
						});
						if (!isSelected) {
							self.innerValue.students.push(selection);
						}
						self.$emit('input', self.innerValue)
					},
					selected: this.search.students,
					data: students,
					captionKey: "displayName",
                    subcaptionKey: "studentid",
					studentSearchFilters: true,
					selectAllBtn: true
				});
			});
		},
		removeStudent(selection) {
			const self = this;
			self.innerValue.students.find((student, i) => {
				if (student.id === selection.id) {
					self.$delete(self.innerValue.students, i);
					self.$emit('input', self.innerValue)
					return true;
				}
			});
			return false;
		},
        clearTeachers() {
            const newVal = this.innerValue
            newVal.teachers = []
            this.$emit('input', newVal)
        },
        clearStudents() {
            const newVal = this.innerValue
            newVal.students = []
            this.$emit('input', newVal)
        },
        selectFilter() {
            const newFilters = this.innerValue
			this.$store.commit("openModal", {
				type: "selector",
				title: this.$t("select-filter"),
				selectCallback: (selection) => {
					if(this.innerValue.filter == selection) {
						newFilters.filter = null;
					} else {
						newFilters.filter = selection;
					}
					this.$emit('input', newFilters)
					this.$store.commit("closeModal");
				},
				selected: this.innerValue.filter ? [this.innerValue.filter] : [],
				data: this.filters,
				captionKey: "caption"
			});
		},
		selectTest() {
            const newFilters = this.innerValue
			this.$store.commit("openModal", {
				type: "selector",
				title: this.$t("select-test"),
				selectCallback: (selection) => {
					if(newFilters.test == selection) {
						newFilters.test = null;
					} else {
						newFilters.test = selection;
					}
					this.$emit('input', newFilters)
					this.$store.commit("closeModal");
				},
				selected: this.innerValue.test ? [this.innerValue.test] : [],
				data: this.filteredTests,
				captionKey: "name"
			});
		},
    },
    computed: {
        isTeacher: function() {
			return this.$UserSession.hasPriv.call(this, "APP_TEACHER");
		},
		isStudent: function() {
			return this.$UserSession.hasPriv.call(this, "APP_STUDENT");
		},
		canViewAllTests() {
			return this.$UserSession.hasPriv.call(this, "VIEW_ALLTESTS");
		},
    },
	watch: {
        innerValue: {
            deep: true,
            handler: function(val) {
				if (!val.programme) val.year = null
				this.$emit('input', val)
            }
        }
    }
}
</script>

<style lang="scss">
.advanced {
    transition: all 400ms ease-in-out;
}
.hide {
    max-height: 0;
    opacity: 0;
    pointer-events: none;
}
.show {
    max-height: 1000px;
    opacity: 1;
}
</style>